import { extendObservable } from 'mobx';

class PageStore {
  constructor(props) {
    extendObservable(this, {
      currentPage: props.current_page,
      numPages: props.num_page,
    });
  }
}

export default PageStore;
